import { PokemonI } from "interfaces";
import { useEffect, useState } from "react";
import { getPokemonProfile } from "../apis/pokemons";

export function useFetchPokemonProfile(
  pokemonIdName: string
): [PokemonI, boolean, string] {
  const [pokemon, setPokemon] = useState<PokemonI>(Object);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancel = false;
    async function fetchData() {
      try {
        setIsLoading(true);
        const fetchedPokemon: PokemonI = await getPokemonProfile(pokemonIdName);
        if (!cancel) {
          setIsLoading(false);
          setPokemon(fetchedPokemon);
        }
      } catch (error) {
        console.log("ERREUR");
        setError("Erreur");
      }
    }
    fetchData();
    return () => {
      cancel = true;
    };
  }, [pokemonIdName]);

  return [pokemon, isLoading, error];
}
